js_slide_products()
function js_slide_products(){
    document.addEventListener('DOMContentLoaded', slideProducts)
}

// slider products
function slideProducts() {
    const slides = document.querySelectorAll('.js-slide-products')

    if (slides != null) {
        init()
    }

    function init() {
        slides.forEach(slide => {
            slideContent(slide.dataset.id)
        })
    }

    function slideContent(id) {
        $(`.js-slide-products__${id}`).slick({
            dots: true,
            arrows: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 7000,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            prevArrow: $(`.js-slide-products__prev-${id}`),
            nextArrow: $(`.js-slide-products__next-${id}`),
            responsive: [ 
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
        })
    }
}